/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";
import * as Sentry from "@sentry/remix";
import { useMatches } from "react-router";

import { sentryConfig } from "./configs/sentryConfig";

import pkg from "../package.json";

// Write client app version to window
window.CLIENT_APP_VERSION = pkg.version;

Sentry.init({
  dsn: sentryConfig.SentryDSN,
  tracesSampleRate: 1.0,
  // Add request headers and IP for users
  sendDefaultPii: true,
  release: sentryConfig.SentryRelease,
  environment: import.meta.env.MODE,
  debug: false,
  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    Sentry.captureConsoleIntegration({ levels: ["error"] }),
  ],
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});
